import { arrayToObj } from '@/utils/utils'

export const STATUS_ARR = [
  { key: 'OK', label: 'OK' },
  { key: 'WARNING', label: 'WARNING' },
  { key: 'ERROR', label: 'ERROR' },
]
export const STATUS_MAP = arrayToObj(STATUS_ARR, 'key')

export const INSPECT_STATUS_ARR = [
  { key: 'BUSY', label: 'BUSY' },
  { key: 'IDLE', label: 'IDLE' },
]
export const INSPECT_STATUS_MAP = arrayToObj(INSPECT_STATUS_ARR, 'key')

export const INSPECT_CHECK_STATUS_ARR = [
  { key: 'OK', label: 'OK' },
  { key: 'WARNING', label: 'WARNING' },
  { key: 'ERROR', label: 'ERROR' },
]
export const INSPECT_CHECK_STATUS_MAP = arrayToObj(INSPECT_CHECK_STATUS_ARR, 'key')
